import type { PocketSettings } from '../services/apiService';

/**
 * Pocket money in the app (2026-10-14). The server decides the real amounts
 * (supabase/functions/_shared/pocketMoney.ts); `pocketMoneyFor` is the same rule, used for the
 * parents' live example while they set it up.
 */
const num = (v: unknown) => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
};

export function pocketMoneyFor(s: PocketSettings, stars: number): { amount: number; capped: boolean } {
  const got = Math.max(0, Math.floor(stars));
  let raw = 0;
  if (s.model === 'per_stars') raw = Math.floor(got / 10) * num(s.per_ten_amount);
  else {
    const threshold = Math.max(0, Math.floor(Number(s.threshold_stars) || 0));
    if (got >= threshold) {
      raw = num(s.fixed_amount);
      const every = Math.floor(num(s.bonus_every));
      if (num(s.bonus_amount) && every) raw += Math.floor((got - threshold) / every) * num(s.bonus_amount);
    }
  }
  const cap = s.monthly_cap != null && Number(s.monthly_cap) >= 0 ? Number(s.monthly_cap) : null;
  return { amount: cap != null ? Math.min(raw, cap) : raw, capped: cap != null && raw > cap };
}

/** "125 kr." / "€12.50" in the app's language. */
export function formatMoney(amount: number, currency: string, language: string): string {
  try {
    return new Intl.NumberFormat(language, { style: 'currency', currency, maximumFractionDigits: amount % 1 ? 2 : 0 }).format(amount);
  } catch {
    return `${amount} ${currency}`;
  }
}

/** "oktober" for "2026-10". */
export function monthName(ym: string, language: string, withYear = false): string {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 15).toLocaleDateString(language, withYear ? { month: 'long', year: 'numeric' } : { month: 'long' });
}

/** Currencies offered in the settings (the family's own stays even if not listed). */
export const CURRENCIES = ['DKK', 'SEK', 'NOK', 'EUR', 'ISK', 'PLN', 'GBP', 'USD', 'CHF', 'AUD', 'CAD', 'NZD'];
